import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsSelect } from './cjsSelect';
import { cjsEffects } from './../cjsObjects/cjsEffects';

var category = false,
  puzzle = [];

export class cjsPuzzle extends cjsSelect {
  _idPuzzle = false;
  _speed = 0;

  constructor(obj) {
    super(obj);
  }

  create() {
    if (typeof this.otherProperty.registrationPoint !== 'object') this.otherProperty.registrationPoint = {};
    this.otherProperty.registrationPoint.x = this.pos.width / 2;
    this.otherProperty.registrationPoint.y = this.pos.height / 2;

    super.create();

    if (typeof this.check !== 'object' || this.check === null) {
      this.check = false;

      this._speed =
        typeof this.otherProperty.pair === 'object' &&
        typeof this.otherProperty.pair.hide === 'object' &&
        fJS.isNumeric(this.otherProperty.pair.hide.speed) === true
          ? this.otherProperty.pair.hide.speed
          : this._stage.defConfig.pair.hide.speed;
      return;
    }

    this.check.toVisible = true;
    this.check.visible = false;
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);
  }

  stageMouseClick(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (engine.block === true) {
      e.stopPropagation();
      return false;
    }

    if (engine.check === false || typeof engine.check !== 'object' || engine.check === null) {
      let item = false;
      if (engine.correct.length === 0) item = stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem];
      else item = engine;

      let isCorrect = false;
      for (let i = 0; i < item.correct.length; i++) {
        isCorrect =
          fJS.isEqual(item.correct[i], {
            idGroup: category.idGroup,
            idItem: category.id,
          }) === true
            ? true
            : isCorrect;
      }
      if (isCorrect === false) {
        e.stopPropagation();
        return false;
      }
    } else {
      if (category !== engine) {
        category.check._container.visible = false;
        category.check._container.parent.updateCache();
        engine.check._container.visible = true;
        engine.check._container.parent.updateCache();
        category = engine;
      }

      e.stopPropagation();
      return false;
    }

    stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem].isCorrect = engine.isCorrect = true;
    stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem].time = engine.time = new Date();
    stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem].toVisible = engine.toVisible = false;
    stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem].wait = engine.wait = 0;
    stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem].effect = engine.effect = 'hide';

    puzzle.push(stage.groups[engine.idPuzzle.idGroup].items[engine.idPuzzle.idItem], engine);
    e.stopPropagation();
    return false;
  }

  get idPuzzle() {
    return this._idPuzzle;
  }
  get speed() {
    return this._speed;
  }
}

cjsPuzzle.resetGameAction = function (stage) {
  console.log('cjsPuzzle RESET');
  puzzle.splice(0, puzzle.length);
  category = false;
};

cjsPuzzle.afterLoadSamples = function (stage) {
  cjsItem.afterLoadSamples(stage);
  stage.update();
  if (category !== false) return;

  for (let gr in stage.groups) {
    if (category !== false) break;
    for (let i in stage.groups[gr].items) {
      if (typeof stage.groups[gr].items[i].check !== 'object' || stage.groups[gr].items[i].check === false) {
        continue;
      }
      category = stage.groups[gr].items[i];
      category.check._container.visible = true;
      break;
    }
  }
};

cjsPuzzle.afterPromises = function (stage) {
  console.log('cjsPuzzle afterPromises');
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      if (
        typeof item.otherProperty === 'object' &&
        typeof item.otherProperty.idPuzzle === 'string' &&
        gr !== item.otherProperty.idPuzzle
      ) {
        let t = new createjs.Point(item.container.parent.x + 1 + item.x, item.container.parent.y + 1 + item.y);
        for (let j = 0; j < stage.stage.getObjectsUnderPoint(t.x, t.y).length; j++) {
          let obj = stage.stage.getObjectsUnderPoint(t.x, t.y)[j];
          if (typeof stage.groups[item.otherProperty.idPuzzle].items[obj.id] !== 'object') {
            continue;
          }
          item._idPuzzle = {
            idGroup: item.otherProperty.idPuzzle,
            idItem: obj.id,
          };
          stage.groups[item.otherProperty.idPuzzle].items[obj.id]._idPuzzle = {
            idGroup: gr,
            idItem: i,
          };
        }
      }
    }
  }
};

cjsPuzzle.tick = function (stage) {
  for (let i = 0; i < puzzle.length; i++) {
    let item = stage.groups[puzzle[i].idGroup].items[puzzle[i].id];
    item._moved = true;
    if (cjsEffects[item.effect].call(this, item) === false) {
      continue;
    }

    item._moved = false;
    puzzle.splice(i, 1);
  }
};
